import { Moment } from 'moment';
import { AvailabilityLevel } from './common';

export default class PlannerCalendarEvent {
  date!: Moment;
  availabilityLevel: AvailabilityLevel | null = null;
}